import { default as FWAircraftHistory } from './aircraft-history';

export default FWAircraftHistory;